import config from "config";
import { useQuery } from "@tanstack/react-query";
import useFetchWithAuth from "../useFetchWithAuth";

const usePromptTemplate = (name) => {
    const fetchWithAuth = useFetchWithAuth();

    const url = config.backend_url + "/prompt_templates/" + name;

    const fetchPromptTemplate = async () => {

        if(!name) {
            return;
        }
        const res = await fetchWithAuth(url).then(res => res.json());
        return res;
    }

    return useQuery(["prompt_template", name], fetchPromptTemplate);
}

export default usePromptTemplate;